import { SxProps, Theme } from '@mui/material';

const style: SxProps<Theme> = [
  {
    padding: 0,
  },
];

export default style;
